import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

const TIME_REGEX = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/

// TODO: At some point, unify this form and ShiftForm to handle create/edit together
class ShiftsEditForm extends Form {
  constructor(values: object) {
    super(values, {
      name: 'string',
      startAt: 'string',
      endAt: 'string',
      notes: 'string',
      extraHours: 'boolean',
      locationId: 'string',
      workAreaId: 'string',
      // EmployeeSelectorInput uses kebab case
      employee_id: 'string',
    })
    makeObservable(this, {
      startAt: computed,
      endAt: computed,
      isValidStartAt: computed,
      isValidEndAt: computed,
    })
  }

  get startAt() {
    return moment(this.get('startAt').value, 'HH:mm')
  }

  get endAt() {
    return moment(this.get('endAt').value, 'HH:mm')
  }

  get isValidStartAt(): boolean {
    const value = this.get('startAt').value
    return value.length > 0 && TIME_REGEX.test(value)
  }

  get isValidEndAt(): boolean {
    const value = this.get('endAt').value
    return value.length > 0 && TIME_REGEX.test(value)
  }

  validate(): boolean {
    this.resetErrors()
    // Empty value '' when is mixed values.
    const startAt = this.get('startAt')
    const endAt = this.get('endAt')

    if (startAt.value && !this.isValidStartAt) {
      startAt.setErrors([i18n.t('shift_management.actions_sidepanel.errors.no_time_frame')])
    }

    if (endAt.value && !this.isValidEndAt) {
      endAt.setErrors([i18n.t('shift_management.actions_sidepanel.errors.no_time_frame')])
    }

    return !this.hasErrors
  }
}

export default ShiftsEditForm
